// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"671":"58c8a558","879":"ef08fbb0","897":"efd9f131"}[chunkId] + ".chunk.js";
};